import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

// Static pages (glossary, guide, about, api, privacy, terms, resolvers) inherit
// this module script from dist/index.html's <head> but render no #root — they
// are plain HTML. Mounting unconditionally threw React error #299 ("target
// container is not a DOM element") on every one of them. Bail out quietly
// instead; the nav's theme toggle there is driven by the inline script in
// index.html, not by React.
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
